import styled from 'styled-components';

export const HeaderSection = styled.div`
  position: relative;

  img {
    object-fit: cover;
  }
`;

export const ContentWrapper = styled.div`
  margin: 0 115px;
  max-width: 700px;
  width: 100%;
  height: 100%;
  transition: margin ease-in-out 0.3s;

  & > div:first-child {
    margin-top: 60px;
  }

  @media only screen and (max-width: 900px) {
    margin: 0 32px;
  }

  @media only screen and (max-width: 480px) {
    padding: 0 16px;
    margin: 0;
  }
`;

export const HeaderBackgroundImage = styled.img`
  height: 200px;
  width: 100%;
  transition: height ease-in-out 0.3s;

  @media only screen and (max-width: 900px) {
    height: 113px;
  }

  @media only screen and (max-width: 480px) {
    height: 53px;
  }
`;

export const CompanyLogoWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 12px;
  padding: 6px;
  filter: drop-shadow(0px 0px 19px rgba(65, 65, 65, 0.07));
  position: absolute;
  bottom: -40px;
  margin-left: 115px;
  background-color: ${({ theme }) => theme.colors.primary.white};
  transition: margin-left ease-in-out 0.3s;

  img {
    width: 68px;
    height: 68px;
  }

  @media only screen and (max-width: 900px) {
    margin-left: 32px;
  }

  @media only screen and (max-width: 480px) {
    margin-left: 16px;
  }
`;

export const PageWrapper = styled.div`
  height: 100vh;
`;
